import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/insights/sport-participation/stats",
)({
  component: () => <Outlet />,
  errorComponent: ({ error }) => <ErrorBoundaryComponent error={error} />,
});
